// ── On-demand xterm (TPT495) ──
//
// xterm.js is close to half the size of the rest of the app and only a remote terminal needs it, so
// it ships as its own bundle (xterm-bundle.js, built beside the main one by web/build.js) and loads
// the first time a terminal opens. Every other page stays free of it. build.js writes the hashed
// file name into this meta tag.

const META_SELECTOR = 'meta[name="tipatask-terminal-bundle"]';

let loading = null;

// Resolves `{ Terminal, FitAddon }`. A failed load (offline, or a deploy replaced the hashed file
// under an old page) is not remembered, so the next open tries again.
export function loadXterm(doc = document, global = window) {
  if (global.TipataskXterm) return Promise.resolve(global.TipataskXterm);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const src = doc.querySelector(META_SELECTOR)?.content;
    if (!src) {
      reject(new Error('Terminal bundle is not available'));
      return;
    }
    const script = doc.createElement('script');
    script.src = src;
    script.onload = () => {
      if (global.TipataskXterm) resolve(global.TipataskXterm);
      else reject(new Error('Terminal bundle did not load'));
    };
    script.onerror = () => {
      script.remove();
      reject(new Error('Terminal bundle did not load'));
    };
    doc.head.appendChild(script);
  }).finally(() => {
    loading = null;
  });
  return loading;
}
